import { StateParams } from "@uirouter/angularjs";
import { ApplicationSetting } from "../../entities/ApplicationSetting";
import { EmployeeWorkHoursModel } from "../../models/edit/EmployeeWorkHoursModel";

export class EmployeeWorkHoursCtrl {
    employeeId: number;
    dateFormat: string;
    workHourGridOptions: any;
    public static $inject = ['$scope', '$stateParams', 'EmployeeWorkHoursModel']
    constructor(public $scope: any, public stateParamsService: StateParams, public model: EmployeeWorkHoursModel) {
        $scope.vm = this;
        this.employeeId = stateParamsService["id"];
        this.dateFormat = ApplicationSetting.applicationSetting.dateFormat;
        this.workHourGridOptions = {
            columnDefs: [{ field: 'date', name: 'Date', cellFilter: 'date:\'yyyy-MM-dd\'', width:200 },
                { field: 'arrived', name: 'Arrived', cellFilter: "date:'HH:mm'", width: 200 },
                { field: 'departed', name: 'Departed', cellFilter: "date:'HH:mm'", width: 200 },
                { field: 'hoursWorked', name: 'Hours Worked', width: 200, cellFilter: "number:2" }],
            data: [],
        };
        this.model.init(this.employeeId).then((ok: boolean) => {
            this.workHourGridOptions.data = this.model.allWorkHours;
        });
    }
}
